import { Formik, Form, Field, FieldArray, ErrorMessage } from 'formik';
import React, { useState, useEffect } from 'react';
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { date } from 'yup/lib/locale';
import Select from 'react-select'
import * as AiIcons from 'react-icons/ai';
import { useQueryClient } from 'react-query'
import * as Yup from "yup";

function Auditee() {
    const { orgcode } = useParams()
    const queryClient = useQueryClient();
    const [initialValues, setInitialValues] = useState({
        _id: "",
        orgCode: 0,
        orgName:"",
        auditeeDetails: [{
            auditeeName: "",
            auditeeDesignation: "",
            auditeeDepartment: "",
            auditeeEmail: "",
            auditeeMobileNum: ""
        }]

    })
    
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        resetForm({
            _id: "",
            orgCode: 0,
            orgName:"",
            auditeeDetails: [{
                auditeeName: "",
                auditeeDesignation: "",
                auditeeDepartment: "",
                auditeeEmail: "",
                auditeeMobileNum: ""
            }]
    
        })

        if (values._id === "") {
           
            mutation.mutate(values)

        } else{
           
             mutationEdit.mutate(values)

        }
       
    }

    const mutation = useMutation((params) => Fetcher('post', '/api/auditee/post/data', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Audit Team Data Added')
                window.location.href= "/"+localStorage.getItem("role")+'/viewauditeedetails/'+ data.data.response.orgCode

               // history.push('/viewauditplan/' + data.data.response.orgCode);
            } else {
                var msg = 'Auditee - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Auditee' + error)
        }
    })

    const { data: OrgList, isLoading: companyListLoading } = useQuery(
        'listAuditPlan',
        () => Fetcher('get', '/api/rfq/get/listofcompaniesofplaneddata/'+localStorage.getItem('userCode'), {}))
        

        const mutationgetCompanyDetails = useMutation((params) => 
         
             Fetcher('get', '/api/auditee/get/auditeedetails/' + params, {}), {
                onSuccess(data) {
                    if (data.data.errorCode === 0) {
                    console.log("data ini", data.data.response)
                        var tempInitialValues = data.data.response;
                        
                    
                        tempInitialValues.auditeeDetails = data.data.response.auditeeDetails ||   [{
                            auditeeName: "",
                            auditeeDesignation: "",
                            auditeeDepartment: "",
                            auditeeEmail: "",
                            auditeeMobileNum: ""
                        }]
                  
                        setInitialValues(tempInitialValues)
                    
                    } 
                    else{
                       
                        var orgList = OrgList.data.response
                        var org = orgList.find(e=>e.value === parseInt(data.data.response) )
                        var tempInitialValues = {
                            _id:"",
                            orgCode:org.value,
                            orgName:org.label,
                            auditeeDetails:  [{
                                auditeeName: "",
                                auditeeDesignation: "",
                                auditeeDepartment: "",
                                auditeeEmail: "",
                                auditeeMobileNum: ""
                            }]
                        };
                     
                        setInitialValues(tempInitialValues)

                    }
                },
                onError(error) {
                    console.log('Got error from backend', error)
                    ToastInstance('Error', 'Get Company Details' + error)
                }
            
        })

      
   
        const { data: auditeeList, isLoading } = useQuery(
            'listauditee',
            () => 
                Fetcher('get', '/api/auditee/get/auditeedetails/'+orgcode, {}))
       
    
            
        useEffect(() => {
          
            if( auditeeList && initialValues.orgCode === 0)
            {   
            
                var tempData                        = auditeeList.data.response
                setInitialValues(tempData)
    
            }
        }, [orgcode && !isLoading && initialValues.orgCode === 0 ])

       

        const mutationEdit = useMutation((params) => Fetcher('patch', '/api/auditee/patch/auditeedetails', params), {
            onSuccess(data) {
               
                if (data.data.errorCode === 0) {
                   
                    ToastInstance('Success', 'Data Updated')
                    queryClient.invalidateQueries('listauditee');
                    window.location.href= "/"+localStorage.getItem("role")+'/viewauditeedetails/'+ data.data.response.orgCode
                   
                  
                } else {
                    var msg = 'Subject - ' + data.data.errorMsg;
                    ToastInstance('Error', msg)
                }
            },
            onError(error) {
                console.log('Got error from backend', error)
                ToastInstance('Error', 'Subject' + error)
            }
        })
        if (companyListLoading  ) return <h1>Loading</h1>
    return (


        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            // validationSchema={validationSchema}
            validationSchema={Yup.object({
                orgName : Yup.string().required("Required"),
                auditeeDetails: Yup.array().of(
                  Yup.object().shape({
                    auditeeName         : Yup.string().required("Required"),
                    auditeeDesignation  : Yup.string().required("Required"),
                    auditeeDepartment   : Yup.string().required("Required"),
                    auditeeEmail        : Yup.string().email('Invalid Email Format').required('Required!!').required("Required"),
                    auditeeMobileNum    : Yup.string().trim().required('Required!!').matches(/^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/, "Phone Number is Invalid")
                  })
                )
              })}
        onSubmit={onSubmit}
        >
            {
                formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body" style={{minHeight:"450px"}}>
                                        <div className="formOuterDiv">
                                        <div className="form1RowDiv">
                                                       
                                                         <FormikControl control='selectNACECode' name='orgCode' options={OrgList.data.response}  label='Organization name' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} />
                                                         <ErrorMessage name={`orgCode`} />
                                                    </div>
                                              
                                                    <div className="container-fluid mt-4 mb-3" >
                                                       
                                                        <div className="row">
                                                            <FieldArray name='auditeeDetails'>
                                                                {fieldArrayProps => {
                                                                    const { push, remove, form } = fieldArrayProps
                                                                    const { values } = form
                                                                    const { auditeeDetails } = values
                                                                    return (
                                                                        <div>
                                                                            {auditeeDetails && auditeeDetails.map((auditeeDetail, index) => (
                                                                                <div key={index}>
                                                                                    <div className="row mt-3">
                                                                                     

                                                                                        <div className="col-sm-2">
                                                                                        <label htmlFor="staticEmail">Auditee Name 
                                                                                        <span className="required-field"> * </span>
                                                                                        </label>
                                                                                            <Field className="form-control" name={`auditeeDetails[${index}].auditeeName`} />
                                                                                            <div style={{color:"red",fontSize :"13px"}}>
                                                                                            <ErrorMessage  name={`auditeeDetails.${index}.auditeeName`} />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-sm-2">
                                                                                        <label htmlFor="staticEmail" >Designation
                                                                                        <span className="required-field"> * </span>
                                                                                        </label>
                                                                                            <Field className="form-control" name={`auditeeDetails[${index}].auditeeDesignation`} />
                                                                                            <div style={{color:"red",fontSize :"13px"}}>
                                                                                            <ErrorMessage style={{color:"red"}} name={`auditeeDetails.${index}.auditeeDesignation`} />
                                                                                                </div>
                                                                                        </div>
                                                                                        <div className="col-sm-2">
                                                                                        <label htmlFor="staticEmail" >Departmant   <span className="required-field"> * </span></label>
                                                                                            <Field className="form-control" name={`auditeeDetails[${index}].auditeeDepartment`} />
                                                                                           
                                                                                            <div style={{color:"red",fontSize :"13px"}}>
                                                                                            <ErrorMessage style={{color:"red"}} name={`auditeeDetails.${index}.auditeeDepartment`} />
                                                                                                </div>
                                                                                        </div>

                                                                                        <div className="col-sm-2">
                                                                                        <label htmlFor="staticEmail" >Email   <span className="required-field"> * </span> </label>

                                                                                            <Field className="form-control" name={`auditeeDetails[${index}].auditeeEmail`} />
                                                                                           
                                                                                            <div style={{color:"red",fontSize :"13px"}}>
                                                                                            <ErrorMessage style={{color:"red"}} name={`auditeeDetails.${index}.auditeeEmail`} />
                                                                                                </div>
                                                                                        </div>
                                                                                        <div className="col-sm-2">
                                                                                        <label htmlFor="staticEmail">Mobile Number   <span className="required-field"> * </span></label>
                                                                                            <Field className="form-control" name={`auditeeDetails[${index}].auditeeMobileNum`} />
                                                                                           
                                                                                            <div style={{color:"red",fontSize :"13px"}}>
                                                                                            <ErrorMessage style={{color:"red"}} name={`auditeeDetails.${index}.auditeeMobileNum`} />
                                                                                                </div>
                                                                                        </div>
                                                                                        {index > 0 && (
                                                                                            <div className="col-sm-1">
                                                                                                <span style={{ "marginLeft": "6%", "cursor": "pointer" }} onClick={() => remove(index)}><AiIcons.AiOutlineDelete style={{ widh: "30px" }} /></span>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            ))}

                                                                            <div className="row mt-3">
                                                                                <div className="col-lg-11"></div>
                                                                                <div className="col-lg-1 mb-3" >
                                                                                    <button type='button' className="btn btn-primary" onClick={() => push('')}>Add</button>
                                                                                </div>
                                                                            </div>


                                                                        </div>

                                                                    )
                                                                }}
                                                            </FieldArray>
                                                        </div>
                                                    </div>
                                                </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                  

                    <div className="card-footer">
                                <div className="row">
                                <div className="col-sm-10"></div>
                                <div className="col-sm-2">
                                    <button className="btn btn-primary float-right" type="submit" >Submit</button>
                                </div>
                                
                            </div>
                            </div>
                </Form>
            }
        </Formik>
    )
}
export default Auditee